<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content">
            <div class="grid-item grid-item-full">
                <p>Reset Reminder would just stop current attempts line and start all over from a {{relatedEvent}} related time</p>
            </div>
            <div class="grid-item grid-item-full" v-if="canHaveRole">
                <div class="field">
                    <h3 class="field-label stack-s">Reminder to reset</h3>
                    <v-radio
                        v-for="(title, id) in selectableRoles"
                        class="stack-s"
                        :key="id"
                        :group="groupName"
                        :label="title"
                        :value="id"
                        :model="role"
                        @update="updateRole"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import shortid from 'shortid';
    import {vRadio} from '@/components/form';
    import {required} from 'vuelidate/lib/validators';
    import ReminderAction from '@/modules/rules-engine/actions/reminder-action';

    export default {
        name: 'reset-reminder',
        extends: ReminderAction,
        components: {
            vRadio,
        },
        data() {
            return {
                groupName: `remove-reminder-${shortid.generate()}`,
            };
        },
        validations: {
            action: {
                role: {
                    required,
                    isAvailable(value) {
                        return this.availableRoles.includes(value);
                    },
                },
            },
        },
    };
</script>
